import React, { useEffect, useState } from "react";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import DesktopMenu from "../../../../../common/DesktopMenu/index";
import MobileMenu from "../../../../../common/MobileMenu/index";
import useWindowSize from "../../../../../common/windowSize";
import NewFooter from "../../../../../common/NewFooter";
import { Background } from "../../../../../common/Faq/styles";
import { LoginButton } from "../../../../Login/styles";
import { SettingsHeader, Title } from "../../../../User/styles";
import BackButton from "../../../../Products/BackButton";
import { privateAPI } from "../../../../../utils/api";
import { getCookie } from "../../../../../utils/cookie";
import {
  StripeForm,
  AmountWrapper,
  Amount,
  CardWrapper,
  Card,
  InvoiceInfo
} from "./styles";
import VisaIcon from "../../../../../assets/24 Payment Method Vector Icons/Dark Color/1.png";
import MasterIcon from "../../../../../assets/24 Payment Method Vector Icons/Dark Color/2.png";
import EftIcon from "../../../../../assets/24 Payment Method Vector Icons/Dark Color/25.png";
import AmericanIcon from "../../../../../assets/24 Payment Method Vector Icons/Dark Color/22.png";
import DiscoverIcon from "../../../../../assets/24 Payment Method Vector Icons/Dark Color/10.png";
import InteracIcon from "../../../../../assets/24 Payment Method Vector Icons/Dark Color/26.png";
import MaestroIcon from "../../../../../assets/24 Payment Method Vector Icons/Dark Color/3.png";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const PaymentCard = () => {
  const [userID] = useState(getCookie('userId'));
  const [mobileMenu, setMobileMenu] = useState(false);
  const size = useWindowSize();
  const elements = useElements();
  const stripe = useStripe();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [paying, setPaying] = useState(false);
  const [amount, setAmount] = useState();

  const handleSubmit = async (e) => {
    setPaying(true);
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    try {
      const response = await privateAPI.post(`auth/bacchus/client/payment`);

      const { error: stripeError } = await stripe.confirmCardPayment(response.data, {
        payment_method: {
          card: elements.getElement(CardElement),
        },
      });

      if (stripeError) {
        window.alert("Credit card payment error");
        setPaying(false);
        return;
      }

      if(!stripeError) {
        await privateAPI.post(`auth/bacchus/client/cart/order`, {
          paymentMethod: "card"
        });
        setAmount(0);
      }
      
      setPaying(false);
      navigate('/payment-shipment')
    } catch (error) {
      console.error("An error occurred while processing payment:", error);
      window.alert("An error occurred while processing payment");
      setPaying(false);
    }
    setPaying(false)
  };

  const getUserOrderInfo = async () => {
    setLoading(true);
    try {
      const response = await privateAPI.get(`/auth/bacchus/client/cart/${userID}`);
      setAmount(response.data.totalSum);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    getUserOrderInfo();
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
    <React.Fragment>
      {mobileMenu ? (
        <MobileMenu single={true} />
      ) : (
        <DesktopMenu single={true} />
      )}
      <Background marginTop adminPanel>
        <SettingsHeader>
          <BackButton userPanel />
          <Title>{t('payWithCard')}</Title>
        </SettingsHeader>
        <AmountWrapper>
         {t('yourAmountForPay')}: <Amount>{amount}</Amount>
        </AmountWrapper>
        <StripeForm>
          <CardElement options={{ hidePostalCode: true }}></CardElement>
        </StripeForm>
        <CardWrapper>
          <Card src={VisaIcon}/>
          <Card src={MasterIcon}/>
          <Card src={EftIcon}/>
          <Card src={AmericanIcon}/>
          <Card src={DiscoverIcon}/>
          <Card src={InteracIcon}/>
          <Card src={MaestroIcon}/>
        </CardWrapper>
        <LoginButton
          type="submit"
          onClick={handleSubmit}
          disabled={paying}
          style={{ width: "100px" }}
          >
          {!paying ? 'Pay' : 'Payment in progress'}
        </LoginButton>
        <InvoiceInfo>
          {t('theInvoiceForYourOrder')}
        </InvoiceInfo>
      </Background>
      <NewFooter />
      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.Fragment>
  );
};

export default PaymentCard;
